export default __webpack_public_path__ + "static/media/Girdle of Violent Rage.58107cc3.jpg";